import { getDefaultStore } from "jotai";
import { type GenieSpotlight, genieSpotlightAtom } from "@/store/genie-atoms";

// Set from tool code, outside React. One at a time: a new spotlight replaces
// the one showing.
export function showSpotlight(spotlight: GenieSpotlight | null): void {
  getDefaultStore().set(genieSpotlightAtom, spotlight);
}
